const COLORS = {
  // Reset
  reset: '\x1b[0m',

  // Styles
  bold: '\x1b[1m',
  dim: '\x1b[2m',
  italic: '\x1b[3m',
  underline: '\x1b[4m',
  inverse: '\x1b[7m',
  hidden: '\x1b[8m',
  strikethrough: '\x1b[9m',

  // Foreground colors
  black: '\x1b[30m',
  red: '\x1b[31m',
  green: '\x1b[32m',
  yellow: '\x1b[33m',
  blue: '\x1b[34m',
  magenta: '\x1b[35m',
  cyan: '\x1b[36m',
  white: '\x1b[37m',
  gray: '\x1b[90m',

  // Bright foreground
  brightRed: '\x1b[91m',
  brightGreen: '\x1b[92m',
  brightYellow: '\x1b[93m',
  brightBlue: '\x1b[94m',
  brightMagenta: '\x1b[95m',
  brightCyan: '\x1b[96m',
  brightWhite: '\x1b[97m',

  // Background colors
  bgBlack: '\x1b[40m',
  bgRed: '\x1b[41m',
  bgGreen: '\x1b[42m',
  bgYellow: '\x1b[43m',
  bgBlue: '\x1b[44m',
  bgMagenta: '\x1b[45m',
  bgCyan: '\x1b[46m',
  bgWhite: '\x1b[47m',
  bgGray: '\x1b[100m',

  // Bright background
  bgBrightRed: '\x1b[101m',
  bgBrightGreen: '\x1b[102m',
  bgBrightYellow: '\x1b[103m',
  bgBrightBlue: '\x1b[104m',
  bgBrightMagenta: '\x1b[105m',
  bgBrightCyan: '\x1b[106m',
  bgBrightWhite: '\x1b[107m',
}

type StyleFunction = ((text: string) => string) & {
  [K in keyof typeof COLORS]?: StyleFunction
}

type LoggerType = {
  [K in keyof typeof COLORS]: StyleFunction
}

const applyStyles = (codes: string[]) => {
  return (text: string) => `${codes.join('')}${text}${COLORS.reset}`
}

const createStyleProxy = (styles: string[] = []) =>
  new Proxy(applyStyles(styles), {
    get(_, prop: string) {
      if (COLORS[prop]) {
        return createStyleProxy([...styles, COLORS[prop]])
      }
      throw new Error(`Style "${prop}" does not exist.`)
    },
  })

export const Logger = new Proxy({} as LoggerType, {
  get(_, prop: string) {
    if (COLORS[prop]) {
      return createStyleProxy([COLORS[prop]])
    }
    throw new Error(`Color "${prop}" does not exist.`)
  },
})
